import PropTypes from 'prop-types';
import React from 'react';
import { StyleSheet, View, ViewPropTypes } from 'react-native';
import DRNText from '../../standard/Text/DRNText';
import R from '../../core-res/R';
import { convertSecondsToDisplayTime, calculateRemainingTime } from './utils';
import TYPE from './types';
import labels from './labels';
import { withTheme } from '../../theme';
import DRNCardView from '../../standard/Card/DRNCardView';
class DRNTimer extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            expired: false,
            remaining: 0,
        };
        this.startTimer = () => {
            this.stopTimer();
            const { endTimestamp } = this.props;
            if (!endTimestamp)
                return;
            const { finished, remaining } = calculateRemainingTime(endTimestamp);
            if (finished) {
                this.setState({ expired: true, remaining: 0 });
                return;
            }
            this.setState({ remaining }, () => {
                this.timer = setInterval(this.advanceCountdown, 1000);
            });
        };
        this.stopTimer = () => {
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = null;
            }
        };
        this.advanceCountdown = () => {
            const { remaining } = this.state;
            if (remaining < 1) {
                clearInterval(this.timer);
                this.timer = null;
                this.setState({ expired: true });
                return;
            }
            this.setState({ remaining: remaining - 1 });
        };
        this.getStyle = () => {
            const { theme } = this.props;
            const style = {
                box: {
                    backgroundColor: theme.lightPrimary,
                    borderRadius: R.border.radius.default,
                    alignItems: 'center',
                },
                label: Object.assign({ color: theme.darkNeutral }, R.typography.captionTiny),
                number: Object.assign({ color: theme.darkPrimary }, R.typography.title3),
                numberContainer: {
                    margin: R.spacing.xs,
                },
            };
            return style;
        };
        this.renderBox = (number, label) => {
            const { withLabel, theme } = this.props;
            const dynamicStyles = this.getStyle();
            const backgroundColor = theme.lightStain;
            return (<View style={dynamicStyles.box}>
        <View style={dynamicStyles.numberContainer}>
          <DRNText style={dynamicStyles.number}>{padNumber(number)}</DRNText>
        </View>
        {withLabel && (<View style={[styles.labelContainer, { backgroundColor }]}>
            <DRNText numberOfLines={1} style={dynamicStyles.label}>
              {label}
            </DRNText>
          </View>)}
      </View>);
        };
    }
    componentDidMount() {
        this.startTimer();
    }
    componentDidUpdate(prevProps) {
        const { isAppFocused } = this.props;
        if (isAppFocused && !prevProps.isAppFocused) {
            this.startTimer();
        }
        if (!isAppFocused)
            this.stopTimer();
    }
    render() {
        const { style, type, locale } = this.props;
        const { remaining } = this.state;
        const label = labels[type][locale];
        const { day, hrs, hrsWithoutDay, min, sec } = convertSecondsToDisplayTime(remaining);
        let countdown = (<View style={styles.countdownContainer}>
        <DRNCardView style={styles.cardView}>{this.renderBox(day, label[0])}</DRNCardView>
        <DRNCardView style={styles.cardView}>{this.renderBox(hrs, label[1])}</DRNCardView>
        <DRNCardView style={styles.cardView}>{this.renderBox(min, label[2])}</DRNCardView>
      </View>);
        if (type === TYPE.HMS) {
            countdown = (<View style={styles.countdownContainer}>
          <DRNCardView style={styles.cardView}>{this.renderBox(hrsWithoutDay, label[0])}</DRNCardView>
          <DRNCardView style={styles.cardView}>{this.renderBox(min, label[1])}</DRNCardView>
          <DRNCardView style={styles.cardView}>{this.renderBox(Math.floor(sec), label[2])}</DRNCardView>
        </View>);
        }
        return <View style={style}>{countdown}</View>;
    }
}
DRNTimer.propTypes = {
    style: ViewPropTypes.style,
    type: PropTypes.oneOf(Object.keys(TYPE)),
    withLabel: PropTypes.bool,
    endTimestamp: PropTypes.number.isRequired,
    locale: PropTypes.string,
    theme: PropTypes.object,
    //pass this as false if you want to pause timer when app is inactive
    isAppFocused: PropTypes.bool,
};
DRNTimer.defaultProps = {
    withLabel: false,
    style: {},
    type: TYPE.HMS,
    locale: 'en',
    isAppFocused: true,
};
function padNumber(number) {
    const parsed = number.toString();
    if (parsed.length < 2)
        return `0${parsed}`;
    return parsed;
}
const styles = StyleSheet.create({
    countdownContainer: {
        flexDirection: 'row',
    },
    labelContainer: {
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        borderBottomLeftRadius: R.border.radius.default,
        borderBottomRightRadius: R.border.radius.default,
    },
    cardView: {
        marginRight: R.spacing.xs,
    },
});
const ThemedTimer = withTheme(DRNTimer);
ThemedTimer.TYPE = TYPE;
export default withTheme(ThemedTimer);
